import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@/environments/environment";
import { Cart } from "../interfaces/cart.interface";

@Injectable({
  providedIn: "root",
})
export class CartService {

  constructor(private http: HttpClient) { }

  updateCart(body: string) {
    return this.http.post(`${environment.baseURL}order/cart`, body, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
  }

  getCartsByUsername(userName: string) {
    return this.http.get<Cart>(`${environment.baseURL}order/cart/user/${userName}`);
  }

  getCartsByProductIds(body: any) {
    return this.http.post<Cart>(`${environment.baseURL}order/cart/product-cart`, body);
  }

  getUsersCart(body: any) {
    return this.http.post<Cart>(`${environment.baseURL}order/cart/user-cart`, body);
  }

}
